import React from 'react';
import { ButtonGroup, CancelButton, PrimaryButton, StyledModal } from '../HybridMailStyles';
import { useHybridMail } from '../HybridMailContext';
import Step5Scheduling from '../../BatchJobs/components/Step5Scheduling';
import { BatchJobProvider, useBatchJob } from '../../../../../context/BatchJobContext';
import { message } from 'antd';
import { HYBRID_MAIL, HYBRID_MAIL_ROOM } from '../TranslationValue';

const SchedulingModalContent = ({ t, batchId, onCancel, handleCurrentPage }) => {
  const { handleHybridSubmit } = useBatchJob();

  const cb = () =>{
    onCancel();
    handleCurrentPage('dashboard');
  }

  const handleDummyCall = () => { 
    handleCurrentPage('dashboard');
    message.success('Batch submitted successfully');
  }

  return (
    <div style={{ padding: '20px' }}>
      <Step5Scheduling />
      <ButtonGroup
        style={{ marginTop: '20px', justifyContent: 'flex-end', display: 'flex', gap: '10px' }}
      >
        <CancelButton onClick={onCancel}>
          {t(HYBRID_MAIL_ROOM.CANCEL_BUTTON.key, HYBRID_MAIL_ROOM.CANCEL_BUTTON.value)}
        </CancelButton>
        {/* <PrimaryButton onClick={() => handleHybridSubmit(batchId, cb)}> */}
        <PrimaryButton onClick={() => handleDummyCall()}>
          {/* {t(HYBRID_MAIL.SEND_LETTER.key, HYBRID_MAIL.SEND_LETTER.value)} */}
          {t(HYBRID_MAIL.SEND_LETTER.key, HYBRID_MAIL.SEND_LETTER.value)}
        </PrimaryButton>
      </ButtonGroup>
    </div>
  );
};

const SchedulingModal = () => {
  const {
    batchId,
    handleCurrentPage,
    isSchedulingModalVisible,
    setIsSchedulingModalVisible,
    onRefresh,
    t,
  } = useHybridMail();

  const handleCancel = () => setIsSchedulingModalVisible(false);

  return (
    <StyledModal
      visible={isSchedulingModalVisible}
      onCancel={handleCancel}
      footer={null}
      width={800}
      destroyOnClose
    >
      <BatchJobProvider
        onBatchCreated={() => {
          setIsSchedulingModalVisible(false);
          onRefresh && onRefresh();
        }}
        onReturn={() => setIsSchedulingModalVisible(false)}
      >
        <SchedulingModalContent batchId={batchId} onCancel={handleCancel} t={t} handleCurrentPage={handleCurrentPage} />
      </BatchJobProvider>
    </StyledModal>
  );
};

export default SchedulingModal;
